interface WaveDividerProps {
  color?: string
  flip?: boolean
  height?: number
  className?: string
}

export function WaveDivider({
  color = "var(--background)",
  flip = false,
  height = 56,
  className,
}: WaveDividerProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 1440 80"
      preserveAspectRatio="none"
      className={className}
      style={{
        display: "block",
        width: "100%",
        height,
        transform: flip ? "scaleY(-1)" : undefined,
      }}
    >
      <path
        d="M0 40 Q 180 0 360 40 T 720 40 T 1080 40 T 1440 40 L 1440 80 L 0 80 Z"
        fill={color}
      />
    </svg>
  )
}
